import React, { Component } from 'react';
import { WarningPopupStyles } from '../../../styles';
import { DRAG_N_DROP, REVISION, DATE_CHANGE, DELETE_PHASE, EMPTY_WEEKS } from '../../../Constants/constants';
import { showMsg } from '../../../../course/actions/loaderAlert';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  Modal,
  Card,
  CardHeader,
  IconButton,
  Typography,
  CardContent,
  Grid,
  Button,
  WithStyles,
  withStyles,
} from '@material-ui/core';
import { CloseOutlined as CloseIcon } from '@material-ui/icons';

const WarningStyles = {
  textAlign: 'center',
};
interface WarningPopupProps extends WithStyles<typeof WarningPopupStyles> {
  isDialogOpen: boolean;
  handleResponse: Function;
  confirmationFor: string;
  showMsg: any;
}

interface WarningPopupState {
  isDialogOpen: boolean;
}

class WarningPopup extends Component<WarningPopupProps, WarningPopupState> {
  constructor(props: WarningPopupProps) {
    super(props);
    this.state = {
      isDialogOpen: true,
    };
  }
  handlePopUpClose = () => {
    this.props.handleResponse(false);
    this.setState({
      isDialogOpen: false,
    });
  };

  getConfirmationText = () => {
    switch (this.props.confirmationFor) {
      case REVISION:
        return (
          <>
            <div style={WarningStyles}>
              Marking this phase as revision phase will lead to
              <br />
              shifting of the syllabus of this phase to next phase.
              <br />
              Are you sure you want to mark it as revision ?
            </div>
          </>
        );

      case DRAG_N_DROP:
        return (
          <>
            <div style={WarningStyles}>
              Upon moving this concept/chapter from this phase,
              <br />
              the phase will be deleted.
              <br />
              Do you really want to move it to another phase?
            </div>
          </>
        );
      case DATE_CHANGE:
        return (
          <div style={WarningStyles}>
            Upon changing the dates of the week, the whole plan will now
            <br />
          change as per the updated week format.
            <br />
          Do you really want to change duration format?
          </div>
        );
      case DELETE_PHASE:
        return (
          <>
            <div style={WarningStyles}>
              Deleting this phase will lead to
              <br />
              shifting of all of the syllabus to next phase.
              <br />
              Are you sure you want to delete the phase ?
            </div>
          </>
        );
      case EMPTY_WEEKS:
        return (
          <>
            <div style={WarningStyles}>
            Weeks with 0 concepts might be added  
              <br />
              after changing the dates.
              <br />
              Are you sure you want to change the dates ?
            </div>
          </>
        );
      default:
        return;
    }
  };

  handleNoClick = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    this.props.handleResponse(false);
    this.setState({ isDialogOpen: false });
  };
  handleYesClick = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    this.props.handleResponse(true);
    this.setState({ isDialogOpen: false });
    this.showToastMsg();
  };

  showToastMsg = () => {
    const { showMsg, confirmationFor } = this.props;
    if (confirmationFor === DELETE_PHASE) showMsg('Milestone deleted successfully', 'success');
  };

  render() {
    const { classes } = this.props;
    return (
      <Modal
        className={[classes.fontSizeLG, classes.fontWeight500, classes.modal].join(' ')}
        open={this.state.isDialogOpen}
      >
        <div>
          <Card>
            <CardHeader
              className={classes.modalHeader}
              action={
                <IconButton aria-label='settings' onClick={this.handlePopUpClose}>
                  <CloseIcon className={classes.fontSizeLG} />
                </IconButton>
              }
              title={
                <Typography align='center' className={[classes.fontWeight500, classes.fontSizeLG].join(' ')}>
                  {this.props.confirmationFor === DELETE_PHASE ? 'Delete Confirmation' : 'Update Confirmation'}
                </Typography>
              }
            />
            <CardContent>
              <Grid container spacing={8} alignItems='center'>
                <Grid container direction='row' justify='center' alignItems='center' className={classes.mxWidth500} />
                <Grid container className={classes.mb1x} alignItems='center' justify='center'>
                  <Typography variant='body1' gutterBottom className={classes.fontSizeMD}>
                    {this.getConfirmationText()}
                  </Typography>
                </Grid>
              </Grid>
              <Grid item container justify='flex-end' alignItems='flex-end'>
                <Button
                  variant='outlined'
                  color='primary'
                  className={classes.button}
                  onClick={(event) => this.handleNoClick(event)}
                >
                  No
                </Button>

                <Button
                  variant='contained'
                  color='primary'
                  className={classes.button}
                  onClick={(event) => this.handleYesClick(event)}
                >
                  Yes
                </Button>
              </Grid>
            </CardContent>
          </Card>
        </div>
      </Modal>
    );
  }
}

const mapstatetoprops = (state: any) => ({});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      showMsg: showMsg,
    },
    dispatch
  );

export default connect(
  mapstatetoprops,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(WarningPopupStyles)(WarningPopup));
